import type {
  IDeleteMediaResponse,
  IUpdatedWithPlaceholder,
} from "../../features/gallery/state/gallerySlice";
import { updateProjectGroupThumbnail } from "../../features/projectGroups/state/projectGroupsSlice";
import { updateProjectThumbnail } from "../../features/projects/state/projectsSlice";
import type { IMedia } from "../../model/unityObject";

export const handleMediaPlaceholderRefreshAfterDeletion = ({
  payload,
  dispatch,
  allMedias,
}: {
  payload: IDeleteMediaResponse;
  dispatch: any;
  allMedias: IMedia[];
}) => {
  /* update the relevant stores so its seemless for the users. we need to handle:
      - project_group.source_thumbnail v
      - project.source_thumbnail  v
      - all node edition (in graph)
      - organization.source_logo
      - user.source_avatar
  */

  // Index the org's media once per batch rather than rescanning all of them
  // for every placeholder swap (bulk deletions replay this per deleted media).
  const mediaById = new Map<number, IMedia>();
  allMedias.forEach((m: IMedia) => {
    const id = Number(m.id);
    // NaN keys are skipped: `===` never matched them, but Map.get would.
    if (!Number.isNaN(id) && !mediaById.has(id)) mediaById.set(id, m);
  });

  payload.updatedWithPlaceholders.forEach((updated: IUpdatedWithPlaceholder) => {
    const placeholderMediaObject = mediaById.get(Number(updated.newMediaId)) as IMedia;

    if (updated.modelName === "project-group") {
      dispatch(updateProjectGroupThumbnail(placeholderMediaObject));
    }
    if (updated.modelName === "project") {
      dispatch(updateProjectThumbnail(placeholderMediaObject));
    }
    /* since this one is pretty complex to handle, we instead disabled the "suppress media" button in the context of the graph gallery  
		if (updated.modelName.includes("content-")) {
		}
		*/
  });
  return null;
};
